<template>
  <div>
    <v-row>
      <v-col cols="12" xs="12" sm="4" md="4" class="py-0 my-0">
        <v-text-field
          label="Search Here"
          v-model="searchQuery"
          class="py-0 my-0"
        ></v-text-field>
      </v-col>
      <v-col cols="12" xs="12" sm="4" md="4" class="py-0 my-0">
        <v-select
          :items="searchOptions"
          v-model="selectedSearchOption"
          item-value="value"
          item-text="text"
          return-object
          class="py-0 my-0"
        ></v-select>
      </v-col>
    </v-row>
    <!-- <v-flex class="px-2" xs12 sm2 md2>
        <v-btn color="primary" @click="search">Search</v-btn>
    </v-flex>-->
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1"
      :options.sync="pagination"
      :server-items-length="totalItems"
      :loading="loading"
      :footer-props="footerProps"
    >
      <template v-slot:item.action="{ item }">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.earnCode="{ item }">
        {{ item.earnCode }} - {{ item.earnDesc }}
      </template>
      <template v-slot:item.amount="{ item }">
        {{ Number(item.amount).toLocaleString() }}
      </template>
      <template v-slot:item.isPayrollLook="{ item }">
        {{ item.isPayrollLook ? `Yes` : `No` }}
      </template>
      <template v-slot:item.isMonthly="{ item }">
        {{ item.isMonthly ? `Yes` : `No` }}
      </template>
      <template v-slot:item.isFixedDaily="{ item }">
        {{ item.isFixedDaily ? `Yes` : `No` }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import _ from "lodash";
const API_ENDPOINT =
  "/api/DesignationByGrossPaySetup/getdesignationbygrosspayallowances";
export default {
  props: {
    loading: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    pagination: {
      page: 1,
      pageSize: 10
    },
    headers: [
      {
        text: "",
        value: "action",
        sortable: false
      },
      {
        text: "Allowance or Earning",
        value: "earnCode",
        sortable: true
      },
      {
        text: "Amount",
        value: "amount",
        sortable: true
      },
      {
        text: "Is Amount Pickup in Payroll Allowance by Tenure",
        value: "isPayrollLook",
        sortable: true
      },
      {
        text: "Monthly",
        value: "isMonthly",
        sortable: true
      },
      {
        text: "Fixed Daily",
        value: "isFixedDaily",
        sortable: true
      }
    ],
    selectedSearchOption: {},
    searchQuery: "",
    searchBy: "",
    totalItems: 0,
    items: [],
    footerProps: {
      itemsPerPageOptions: [5, 10, 25, 50]
    },
    searchOptions: [
      {
        text: "Allowance or Earning Code",
        value: "earnCode"
      },
      {
        text: "Allowance or Earning Description",
        value: "earnDesc"
      }
    ]
  }),
  computed: {
    uploadLoading: {
      get() {
        return this.loading;
      },
      set(v) {
        this.$emit("uploadLoading", v);
      }
    }
  },
  methods: {
    getAll() {
      const id = this.$route.params.id;
      if (!id) return;

      this.uploadLoading = true;
      const { page, pageSize, sortBy, sortDesc } = this.pagination;

      const pageNumber = this.searchQuery == "" ? page : 1;
      let sort = "";

      if (sortDesc.length > 0) {
        if (sortDesc[0]) {
          sort = "desc";
        } else {
          sort = "asc";
        }
      }
      this.$axios
        .get(
          `${API_ENDPOINT}?pageNumber=${pageNumber}&pageSize=${pageSize}&designationByGrossPayId=${id}&searchBy=${this.searchBy}&searchQuery=${this.searchQuery}&orderBy=${sortBy}&sort=${sort}`
        )
        .then(({ data }) => {
          this.items = data;

          if (!_.isEmpty(data)) {
            this.totalItems = data[0].totalRecords;
          } else {
            this.totalItems = 0;
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.uploadLoading = false;
        });
    },
    search() {
      const { value } = this.selectedSearchOption;
      this.searchBy = value;

      this.getAll();
    }
  },
  watch: {
    searchQuery() {
      setTimeout(() => {
        this.search();
      }, 500);
    },
    selectedSearchOption() {
      this.search();
    }
  },
  mounted() {
    this.selectedSearchOption = this.searchOptions[0];
  }
};
</script>
